// extracted by mini-css-extract-plugin
export default {"container":"qNvIKT","component":"f21DHg","fade":"EDTunX","ftop":"Xc9MjI","shadow":"MzCBhB","sbottom":"gMT7fR","fbottom":"EhszA3","semistatic":"dsia9f"};